module.exports = __webpack_public_path__ + "static/media/svv-logo-hvit-eng.dabca8b4.svg";